app.http.instance.interceptors.response.use(
  result => {
    let res = result.data;
    if (res && res.code != 200) {
      // 产品要求，验证码频繁获取在机构端，需要区分情况提示
      // 所以这个提示应该在业务层处理
      if (res.code === 710000003) {
        return res;
      }

      if (res.code <= 60000) {
        vant.Toast.fail(res.msg || '服务端出错...');
        return Promise.reject(res);
      }
    }

    return res;
  },
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = '请求错误';
          break;
        case 401:
          err.message = '授权失败，请检查token';
          break;
        case 403:
          err.message = '拒绝访问';
          break;
        case 404:
          err.message = `请求${err.response.config.url
            .split('/')
            .pop()
            .replace(/\.html/, '')}接口出错`;
          break;
        case 408:
          err.message = '请求超时';
          break;
        case 429:
          err.message = '操作过于频繁，请等待1-3秒再试~'
          break
        case 500:
          err.message = '服务器内部错误';
          break;
        case 501:
          err.message = '服务未实现';
          break;
        case 502:
          err.message = '网关错误';
          break;
        case 503:
          err.message = '服务不可用';
          break;
        case 504:
          err.message = '网关超时';
          break;
        case 505:
          err.message = 'HTTP版本不受支持';
          break;
        default:
      }
    }
    vant.Toast.clear();

    vant.Toast.fail(err.message || '接口请求错误...');

    // vant.Notify({ type: "danger", message: err.message ? err.message : '接口请求错误' });
    return Promise.reject(err);
  }
);

// console.log(">>>>>>>>>>>>>>>>");
// console.log(process.env.NODE_ENV);

// 根据环境区分接口前缀
// let apiPre = ""
// if (process.env.NODE_ENV == "development") {
//     apiPre = ""
// } else if (process.env.NODE_ENV == "production") {
//     apiPre = "/api"
// }

function transUrl(url) {
  var inter = {
    // server: `${apiPre}/cs-crm`,
    server: `/api`,
    mock: '/mock',
    json: '/json',
  };

  var ip = app.tool.parseQuery().ip,
    proxy = ip ? `/${ip}` : '';

  if (ip === 'json') {
    url = inter[ip] + url;
  } else {
    url = proxy + inter.server + url;
  }
  return url;
}

app.http.instance.interceptors.request.use(
  config => {
    config.url = transUrl(config.url);

    // if (Lockr.get('token')) {
    //     config.headers.common['Authorization'] = Lockr.get('token')
    // }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
